import { render, staticRenderFns } from "./sbxx.vue?vue&type=template&id=2030836a&scoped=true"
import script from "./sbxx.vue?vue&type=script&lang=js"
export * from "./sbxx.vue?vue&type=script&lang=js"
import style0 from "./sbxx.vue?vue&type=style&index=0&id=2030836a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030836a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2030836a')) {
      api.createRecord('2030836a', component.options)
    } else {
      api.reload('2030836a', component.options)
    }
    module.hot.accept("./sbxx.vue?vue&type=template&id=2030836a&scoped=true", function () {
      api.rerender('2030836a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkequipmentmanagement/components/sbxx.vue"
export default component.exports